import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ClaimService } from "../claims-view/claim.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import swal from "sweetalert2";

@Component({
  selector: "app-eta-claims-view",
  templateUrl: "./eta-claims-view.component.html",
  styleUrls: ["./eta-claims-view.component.scss"],
})
export class EtaClaimsViewComponent implements OnInit {
  id;
  claims_id;
  claim_details;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));

  @ViewChild("topScroll") topScroll: ElementRef;
  @ViewChild("tableScroll") tableScroll: ElementRef;

  payments: any;
  current_payment;

  add_claim = {
    date: null,
    due_date: null,
    title: "",
    description: "",
    user_id: null,
  };

  current_active_cheque: number;
  chequeCollectType: any;

  // cheques book
  enable_edit_payment_collections = false;
  disableSavePaymentCollection = false;
  check_all = false;
  current_active_full_cheque: any;
  enableRemiderType: string;
  disableReminderType: string;
  chequeCollectCustomer: any;
  cheque_amount;
  transaction_number;
  collectModalSubmitting;
  slip_type: any;
  currency_code: any = "EGP";
  partially_method: any;
  partially_data: any;
  exchange_rate: any;
  collect_type = "fully-collected";
  collection_date = "";
  chequeRejectType: any;
  currencies_list;
  current_active_payment;
  cancel_invoice = {
    reason: "",
  };
  holding_tax_percentage;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private slimLoadingBarService: SlimLoadingBarService,
    private claimsService: ClaimService,
    private errorHandlerService: ErrorHandlerService,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.id = +this.route.snapshot.params.id;
    this.claims_id = this.route.snapshot.params.eta_claim_id;
    this.getETACLAIM();
    this.getAllCurrencies();
  }

  getAllCurrencies() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllCurrencies().subscribe(
      (data: any) => {
        this.currencies_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  makeTableScrollable() {
    setTimeout(() => {
      //console.log(this.topScroll, this.tableScroll);

      // Synchronize scroll between the top scrollbar and the actual table
      this.topScroll.nativeElement.addEventListener("scroll", () => {
        this.tableScroll.nativeElement.scrollLeft =
          this.topScroll.nativeElement.scrollLeft;
      });

      this.tableScroll.nativeElement.addEventListener("scroll", () => {
        this.topScroll.nativeElement.scrollLeft =
          this.tableScroll.nativeElement.scrollLeft;
      });
    }, 1000);
  }

  getETACLAIM() {
    this.slimLoadingBarService.start();
    this.claimsService.getETAClaims(this.claims_id).subscribe(
      (res: any) => {
        this.claim_details = res;
        this.payments = res.payments.map((payment) => {
          return {
            ...payment,
            rowSelected: false,
          };
        });

        this.slimLoadingBarService.complete();
        //console.log(res);
        setTimeout(() => {
          this.makeTableScrollable();
        }, 2000);
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  sendToETAExec(payments) {
    swal({
      title: "Are you sure?",
      text: "You will send the payments to ETA",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const payload = {
          reservation_id: this.id,
          payments: payments.map((payment) => {
            return {
              id: payment.id,
              type: payment.type,
            };
          }),
        };
        //console.log(payload);
        this.slimLoadingBarService.start();
        this.reservationService.sendToETA(payload).subscribe(
          (res: any) => {
            swal("Success", "Payments sent to ETA", "success");
            this.getETACLAIM();
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.slimLoadingBarService.reset();
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  selectAll(value) {
    this.payments.forEach((payment) => {
      payment.rowSelected = value;
    });
  }

  openMakeClaim(payment, claimModal) {
    this.current_payment = payment;
    claimModal.open();
  }

  createClaimModalSubmit(ids, modal) {
    let payload = {
      ...this.add_claim,
      ids: null,
      reservation_id: this.id,
    };
    if (this.current_payment) {
      payload.ids = [
        {
          id: this.current_payment.id,
          type: this.current_payment.type,
        },
      ];
    } else {
      payload.ids = this.payments
        .filter((payment) => payment.rowSelected)
        .map((payment) => {
          return {
            id: payment.id,
            type: payment.type,
          };
        });
    }
    this.claimsService.createClaim(payload).subscribe(
      (res: any) => {
        this.getETACLAIM();
        this.add_claim = {
          date: null,
          due_date: null,
          title: "",
          description: "",
          user_id: null,
        };
        swal("Success", "claim created successfully", "success");
        modal.close();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  deleteClaim(ids) {
    let payload = {
      ids: Array.isArray(ids) ? ids : [ids],
    };
    this.claimsService.deleteClaim(this.id, payload).subscribe(
      (res: any) => {
        this.getETACLAIM();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  printPdf(pdf_url) {
    window.open(pdf_url, "_blank");
  }

  onOpenCollectCheque(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.chequeCollectType = type;
    else this.chequeCollectType = null;
    //console.log(this.chequeCollectType);
    modal.open();
  }

  submitCollectCheque(modal) {
    if (this.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return;
    }
    let payload: any = {
      ids: [this.current_active_cheque],
      status: this.collect_type,
      lead_id: this.chequeCollectCustomer,
      partially_method: this.partially_method,
      collection_date: this.collection_date,
      exchange_rate: this.exchange_rate,
      currency_code: this.currency_code,
    };
    if (this.collect_type == "partially-collected") {
      payload.amount_received = this.cheque_amount;
      if (payload.partially_method == "3") {
        payload.partially_data = this.partially_data;
      }
    }
    if (
      this.collect_type === "partially-collected" &&
      this.partially_method != 4
    ) {
      payload.transaction_number = this.transaction_number;
    }
    if (this.isDateGreaterThanToday(this.collection_date)) {
      swal("collection date can not be greater than today", "", "error");
      return;
    }
    if (this.slip_type === "2" || this.slip_type === "3") {
      if (!this.transaction_number) {
        swal("error", "Transaction Number is required", "error");
        return;
      }
    }
    payload.holding_tax_percentage = this.holding_tax_percentage;
    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectCheque(this.id, payload)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.collect_type = null;
          this.current_active_cheque = null;
          this.cheque_amount = null;
          this.partially_method = null;
          this.partially_data = null;
          this.collection_date = "";
          this.chequeCollectCustomer = "";
          this.getETACLAIM();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectModalSubmitting = false;
      });
  }

  isDateGreaterThanToday(date) {
    const inputDate = new Date(date);
    const today = new Date();

    if (inputDate > today) {
      return true;
    }
    return false;
  }

  makeCreditNote(payment) {
    //console.log(this.id);
    this.slimLoadingBarService.start();
    const payload = {
      id: payment.id,
      type: payment.type,
      reservation_id: this.id,
    };
    this.reservationService.makeCreditNote(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.getETACLAIM();
        swal("Woohoo!", "Credit Note created succesfully!", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  openCancelInvoiceModal(payment, cancelInvoiceModal) {
    this.current_payment = payment;
    cancelInvoiceModal.open();
  }

  submitCancelInvoice(cancelInvoiceModal) {
    const payload = {
      ...this.cancel_invoice,
      id: this.current_payment.id,
      type: this.current_payment.type,
    };
    this.slimLoadingBarService.start();
    this.reservationService.cancelInvoice(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        cancelInvoiceModal.close();
        this.getETACLAIM();
        swal("Woohoo!", "Cancel Invoice created succesfully!", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/eta-claims-view/eta-claims-view.component.ts